import { useState } from "react";

const useToast = () => {
  const [toastMessage, setToastMessage] = useState("");
  const [toast, setToast] = useState(false);
  const [toastType, setToastType] = useState("");

  const showToast = (type, message) => {
    setToast(true);
    setToastMessage(message);
    setToastType(type);
  };

  return { toastMessage, toast, toastType, setToast, showToast };
};

export default useToast;
